import dayjs from "dayjs";

export const obtenerTiempoTranscurrido = ({fechaInicio}) => {

    const fechaInicial = dayjs(fechaInicio);
    const fechaFinal = dayjs();

// Obtener meses transcurridos (número entero)
    const meses = fechaFinal.diff(fechaInicial, 'month');

    return meses

}